import styled from "styled-components";
import tw from "twin.macro";

const Container = styled.div`
  ${tw`relative box-border mx-auto w-[95%] max-w-[1200px]`}
`;

export default Container;
